<template>
  <div>
    <app-cookie-notice />
    <router-view />
  </div>
</template>

<script>
import { Options, Vue } from "vue-class-component";

@Options({
  title: "Equity4Talent",
  components: {},
})
export default class extends Vue {}
</script>

<style lang="scss">
@import "./styles.scss";
</style>
